import React from 'react';

import svg from './assets/icons-16-location.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconLocation = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-location" />
);
